var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { attachKey2click, SurveyActionBar, ReactElementFactory, SurveyPage, SvgIcon, LoadingIndicatorComponent } from "survey-react-ui";
import { CreatorModelElement } from "../ModelElement";
import { PageAdorner } from "survey-creator-core";
import { ReactMouseEvent } from "../events";
var PageElementContent = React.memo(function (_a) {
    var page = _a.page, survey = _a.survey, creator = _a.creator;
    return React.createElement(SurveyPage, { page: page, survey: survey, creator: creator });
});
PageElementContent.displayName = "PageElementContent";
var CreatorSurveyPageComponent = /** @class */ (function (_super) {
    __extends(CreatorSurveyPageComponent, _super);
    function CreatorSurveyPageComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.rootRef = React.createRef();
        return _this;
    }
    CreatorSurveyPageComponent.prototype.createModel = function (props) {
        if (this.model) {
            this.model.attachToUI(props.page, this.rootRef.current);
        }
        this.model = this.createPageAdorner(props.creator, props.page);
        this.model.isGhost = this.props.isGhost;
    };
    CreatorSurveyPageComponent.prototype.createPageAdorner = function (creator, page) {
        return new PageAdorner(creator, page);
    };
    CreatorSurveyPageComponent.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        var res = _super.prototype.shouldComponentUpdate.call(this, nextProps, nextState);
        if (this.model) {
            this.model.isGhost = this.props.isGhost;
        }
        return res;
    };
    CreatorSurveyPageComponent.prototype.componentDidUpdate = function (prevProps, prevState) {
        _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
    };
    CreatorSurveyPageComponent.prototype.getUpdatedModelProps = function () {
        return ["creator", "page"];
    };
    CreatorSurveyPageComponent.prototype.getStateElement = function () {
        return this.model;
    };
    CreatorSurveyPageComponent.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        this.model.attachToUI(this.props.page, this.rootRef.current);
        this.model.isGhost = this.props.isGhost;
    };
    CreatorSurveyPageComponent.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        this.model.detachFromUI();
    };
    CreatorSurveyPageComponent.prototype.canRender = function () {
        return _super.prototype.canRender.call(this);
    };
    CreatorSurveyPageComponent.prototype.renderElement = function () {
        var _this = this;
        if (!this.props.page)
            return null;
        return (attachKey2click(React.createElement("div", { ref: this.rootRef, id: this.props.page.id, "data-sv-drop-target-survey-page": this.model.dropTargetName, className: "svc-page__content " + this.model.css, onClick: function (e) {
                return _this.model.select(_this.model, new ReactMouseEvent(e));
            }, onDoubleClick: function (e) { return _this.model.dblclick(e.nativeEvent); }, onMouseLeave: function (e) { return _this.model.hover(e.nativeEvent, e.currentTarget); }, onMouseOver: function (e) { return _this.model.hover(e.nativeEvent, e.currentTarget); } },
            React.createElement("div", { className: "svc-question__drop-indicator svc-question__drop-indicator--top" }),
            React.createElement("div", { className: "svc-question__drop-indicator svc-question__drop-indicator--bottom" }),
            this.renderContent(),
            this.renderPlaceholder(),
            this.renderHeader(),
            this.renderFooter())));
    };
    CreatorSurveyPageComponent.prototype.renderPlaceholder = function () {
        if (!this.model.showPlaceholder)
            return null;
        return (React.createElement("div", { className: "svc-page__placeholder_frame" },
            React.createElement("div", { className: "svc-panel__placeholder_frame" },
                React.createElement("div", { className: "svc-panel__placeholder" }, this.model.placeholderText))));
    };
    CreatorSurveyPageComponent.prototype.renderContent = function () {
        if (!this.model.needRenderContent) {
            return React.createElement("div", { className: "svc-page__loading-content" },
                React.createElement(LoadingIndicatorComponent, null));
        }
        return (React.createElement(PageElementContent, { page: this.props.page, survey: this.props.survey, creator: this.props.creator }));
    };
    CreatorSurveyPageComponent.prototype.renderHeader = function () {
        var _this = this;
        var actions = (React.createElement("div", { className: "svc-page__content-actions" },
            React.createElement(SurveyActionBar, { model: this.model.actionContainer }),
            (this.model.topActionContainer.hasActions ? React.createElement(SurveyActionBar, { model: this.model.topActionContainer }) : null)));
        if (this.model.isGhost || !this.model.allowDragging) {
            return actions;
        }
        return (React.createElement("div", { className: "svc-question__drag-area", onPointerDown: function (event) { return _this.model.onPointerDown(event); } },
            React.createElement(SvgIcon, { className: "svc-question__drag-element", size: "auto", iconName: "icon-drag-area-indicator_24x16" }),
            actions));
    };
    CreatorSurveyPageComponent.prototype.renderFooter = function () {
        return React.createElement(SurveyActionBar, { model: this.model.footerActionsBar });
    };
    return CreatorSurveyPageComponent;
}(CreatorModelElement));
export { CreatorSurveyPageComponent };
ReactElementFactory.Instance.registerElement("svc-page", function (props) {
    return React.createElement(CreatorSurveyPageComponent, props);
});
